import { useEffect, ReactNode } from "react";

// react-router-dom components
import { Link, useLocation } from "react-router-dom";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React context
import { useMaterialUIController, setLayout } from "context";
import MDAlert from "components/MDAlert";
import { useBitumioContext } from "providers/BitumioContext";

// Declaring props types for PageLayout
interface Props {
  background?: "white" | "light" | "default";
  id?: string;
  children: ReactNode;
}

function PageLayout({ background, children, id }: Props): JSX.Element {
  const [, dispatch] = useMaterialUIController();
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "page");
  }, [pathname]);
  return (
    <MDBox
      width="100vw"
      height="100%"
      minHeight="100vh"
      id={id ?? "pageLayout"}
      bgColor={background}
      sx={{ overflowX: "hidden" }}
    >
      {children}
    </MDBox>
  );
}

// Declaring default props for PageLayout
PageLayout.defaultProps = {
  background: "default",
};

export default PageLayout;
